/**
 * DateRangeFilter Component - T113
 *
 * Date range picker for filtering invoices
 */
import { Input } from '../ui';

interface DateRangeFilterProps {
  dateFrom: string | undefined;
  dateTo: string | undefined;
  onChange: (dateFrom: string | undefined, dateTo: string | undefined) => void;
}

const presets = [
  { label: 'Heute', days: 0 },
  { label: '7 Tage', days: 7 },
  { label: '30 Tage', days: 30 },
  { label: 'Dieses Jahr', days: -1 }, // Special case
];

export function DateRangeFilter({ dateFrom, dateTo, onChange }: DateRangeFilterProps) {
  const handlePreset = (days: number) => {
    const today = new Date();
    const toDate = today.toISOString().split('T')[0];

    if (days === -1) {
      // This year
      const yearStart = new Date(today.getFullYear(), 0, 1).toISOString().split('T')[0];
      onChange(yearStart, toDate);
    } else if (days === 0) {
      // Today only
      onChange(toDate, toDate);
    } else {
      const fromDate = new Date(today.getTime() - days * 24 * 60 * 60 * 1000)
        .toISOString()
        .split('T')[0];
      onChange(fromDate, toDate);
    }
  };

  const handleClear = () => {
    onChange(undefined, undefined);
  };

  const hasRange = dateFrom || dateTo;

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {presets.map((preset) => (
          <button
            key={preset.label}
            onClick={() => handlePreset(preset.days)}
            className="px-3 py-1.5 rounded-full text-sm text-white/50 hover:text-white hover:bg-white/5 transition-colors"
          >
            {preset.label}
          </button>
        ))}
        {hasRange && (
          <button
            onClick={handleClear}
            className="px-3 py-1.5 rounded-full text-sm text-red-400/70 hover:text-red-400 hover:bg-red-500/10 transition-colors"
          >
            Zurücksetzen
          </button>
        )}
      </div>

      <div className="flex items-center gap-3">
        <div className="flex-1">
          <label className="block text-xs text-white/40 mb-1">Von</label>
          <Input
            type="date"
            value={dateFrom ?? ''}
            onChange={(e) => onChange(e.target.value || undefined, dateTo)}
            className="text-sm"
          />
        </div>
        <span className="text-white/30 mt-5">–</span>
        <div className="flex-1">
          <label className="block text-xs text-white/40 mb-1">Bis</label>
          <Input
            type="date"
            value={dateTo ?? ''}
            onChange={(e) => onChange(dateFrom, e.target.value || undefined)}
            className="text-sm"
          />
        </div>
      </div>
    </div>
  );
}
